import styled, {css} from "styled-components";
import {JackpotWidgetAmountContainerDefaultBox} from "./jackpot-widget-amount-container.default.box";

export const JackpotWidgetAmountContainerMrGreenBox = styled(JackpotWidgetAmountContainerDefaultBox)`
    ${({isDaily}) => isDaily ? css`
      padding-bottom: 25%;
    ` : null};
`;
